module.exports = __webpack_public_path__ + "static/media/maple-frame-custom-mat-rendering.509d99b8.webp";